@if (isVisible()) {
  <div class="impersonation-banner" role="alert" aria-live="polite">
    <div class="banner-content">
      <span class="banner-icon" aria-hidden="true">⚠</span>
      <span class="banner-badge">{{ 'TOPBAR.IMPERSONATION_BADGE' | translate }}</span>
      <span class="banner-text">
        <span class="banner-label">{{ 'TOPBAR.IMPERSONATION_ACTING_AS' | translate }}:</span>
        <strong class="banner-customer">{{ customerLabel() }}</strong>
        @if (adminLabel()) {
          <span class="banner-admin">
            · {{ 'TOPBAR.IMPERSONATION_AS_ADMIN' | translate }}: <strong>{{ adminLabel() }}</strong>
          </span>
        }
      </span>
    </div>
    <button type="button" class="banner-exit" (click)="onExit()"
            [matTooltip]="'TOPBAR.IMPERSONATION_EXIT_TOOLTIP' | translate">
      <span>{{ 'TOPBAR.IMPERSONATION_EXIT' | translate }}</span>
      <kbd class="exit-hint">{{ 'TOPBAR.IMPERSONATION_EXIT_HINT' | translate }}</kbd>
    </button>
  </div>
}
